<!--suppress HtmlUnknownTag -->
<template>
    <div style="display: flex;flex-direction: row;align-items: center;gap: 10px">
        <div v-if="data" style="display: flex;flex-direction: row;align-items: center;gap: 10px">
            <img :src="host+o"
                 v-for="(o,i) in data.split(',')"
                 :key="i"
                 title="点击置顶，拖拽删除"
                 class="img"
                 @dragend="remove(i)"
                 @click="toFirst(o,i)"
            >
        </div>
        <el-upload ref="upload" :action="host+'/upload'" :on-success="uploadOk" :show-file-list="false"
                   :auto-upload="true">
            <div slot="trigger" class="add-btn">add</div>
        </el-upload>
    </div>
</template>

<script>
export default {
    name: "MultiImgUploader",
    props: {
        value: String
    },

    data() {
        return {
            host: this.$store.state.backendHost,
            data: this.value
        }
    },
    watch: {
        value(newVal,oldVal){
            this.data = newVal
        }
    },

    methods: {
        remove(i) {
            let imgList = this.data.split(',')
            imgList.splice(i, 1);
            this.data = imgList.join(',')
            this.$emit('input', this.data);
        },
        toFirst(img, index) {
            if (index > 0) {
                let imgList = this.data.split(',')
                imgList.splice(index, 1);
                imgList.unshift(img);
                this.data = imgList.join(',')
            }
            this.$emit('input', this.data);
        },
        uploadOk(response, file) {
            if (this.data) {
                this.data += ','
            }
            this.data += response
            this.$emit('input', this.data);
        },
    },
    mounted() {

    }
}
</script>

<style scoped>
.add-btn:hover {
    background-color: #00a0f1;
}

.add-btn {
    width: 110px;
    height: 40px;
    text-align: center;
    cursor: pointer;
    border-radius: 20px;
    align-content: center;
    justify-content: center;
    background-color: #d2d2d2;
}

.img:hover {
    scale: 1.1;
}

.img {
    height: 50px;
    cursor: pointer;
    transition-property: scale;
    transition-duration: 0.1s;
}
</style>